import React from "react";
import styles from "../css/Yuyue.css";


export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            info: {},
            display: false, // 禁止修改  当查看详情时 true  创建修改 false
            cctj: "",
            jggs: "",
            fplx: "",
            attach: "",
            yphs: "否",
            ypsl: "",
            fp_school: "校内",
            ypjs: "自主送样",
            invoice_id: "",
            receiving_information_id: "",
            recipient_list: [],
            uploaedImages: [
                // {
                //   url:
                //     "http://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/null_1620032180784_ales-krivec-4miBe6zg5r0-unsplash.jpg",
                //   filename: "ales-krivec-4miBe6zg5r0-unsplash.jpg",
                //   name: "null_1620032180784_ales-krivec-4miBe6zg5r0-unsplash.jpg",
                // },
            ],
            fp_list: [],
            sj_list: [],
            cunchu: false,
            jieguo: false,
            info_status: 0,
            page: 1,
            loading: true,
            subBu: true,
        };
    }


    async componentDidMount() {
        let that = this
        setTimeout(() => {
            // that.setState({
            //     ypjs: '自主送样'
            // }, () => {
            //     console.log(that.state.ypjs, '2!!')
            // });

            // that.setState(Object.assign({}, that.state), () => {
            //     console.log(that.state.ypjs, '2!!')
            // });

            let ypjs = "快递邮寄"
            this.setState({
                ypjs: ypjs,
            });
        }, 3000);
        // console.log(that.state.ypjs, '1!!')
    }

    render() {
        return (
            <div className={styles.leftItem}>
                <span className={styles.textareaTitle}>* 送样方式</span>
                <div
                    onChange={(e) => {
                        this.setState({
                            ypjs: e.target.value
                        }, () => {
                            console.log(this.state.ypjs)
                        })
                    }}
                    className={styles.radioRight}

                >
                    <div className={styles.radioRightItem}>
                        <input
                            type="radio"
                            name="ypjs"
                            value="自主送样"
                            checked={this.state.ypjs === "自主送样"}
                        />
                        <span className={styles.pText}>自主送样</span>
                    </div>

                    <div className={styles.radioRightItem}>
                        <input
                            type="radio"
                            name="ypjs"
                            value="快递邮寄"
                            checked={this.state.ypjs === "快递邮寄"}
                        />
                        <span className={styles.pText}>快递邮寄</span>
                    </div>

                </div>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/pages/test.js